import { defineMessages } from 'react-intl';

type MessageKeys = 'selectToEditAriaLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		selectToEditAriaLabel: {
			id: 'company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label',
			defaultMessage: 'Select card to edit',
			description: 'Aira label for button that selects card for editing',
		},
	});

export default message;
